import React, { useState, useEffect } from 'react'
import { Dialog, IconButton, DialogTitle, DialogContent, FormControlLabel, Checkbox } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'

import '../contactos/modalContacts.css'
import { useCatalog } from '../../hooks/useCatalog'
import { DialogProfileCatalogCat } from './DialogProfileCatalogCat'

export const DialogListaCategorias = ({ open, setOpen }) => {

    const { categorias, initLoadCategorias, handleUpdateCat, handleDeleteCat } = useCatalog()
    const [openCat, setOpenCat] = useState(false)

    const [filters, setFilters] = useState({
        check_venta: false,
        check_compra: false
    })

    const [initialCat, setInitialCat] = useState({
        id: 0,
        nombre: '',
        tipo: 'venta',
        codigo: '',
        estado: false,
        descripcion: ''
    })

    useEffect(() => {
        initLoadCategorias(filters)
    }, [filters, initLoadCategorias])

    const handleChangeChecked = ({ target }) => {
        setFilters({
            ...filters,
            [target.name]: target.checked,
        })
    }

    const openEdit = (item) => {
        setInitialCat({
            id: item.id,
            nombre: item.nombre,
            tipo: item.tipo,
            codigo: item.codigo,
            estado: item.estado,
            descripcion: item.descripcion
        })

        setOpenCat(true)

    }

    const openDelete = (item) => {
        console.log('--item--', item)
        handleDeleteCat(item.id)
    }

    return (
        <Dialog
            className='dialogoContacs'
            open={open}
            onClose={() => setOpen(false)}
            aria-labelledby="simple-dialog-title"
        >
            <DialogTitle id="scroll-dialog-title">
                Categorías
                <IconButton
                    aria-label="close"
                    style={{ padding: '0', float: 'right' }}
                    onClick={() => setOpen(false)}
                >
                    <CloseIcon style={{ color: '#78667E' }} />
                </IconButton>

            </DialogTitle>

            <DialogContent>
                <div className='d-flex justify-content-start'>
                    <FormControlLabel
                        className='formControFilterList'
                        control={
                            <Checkbox
                                checked={filters?.check_venta}
                                onChange={handleChangeChecked}
                                name="check_venta"
                                color='secondary'
                            />
                        }
                        label="Venta"
                    />
                    <FormControlLabel
                        className='formControFilterList'
                        control={
                            <Checkbox
                                checked={filters?.check_compra}
                                onChange={handleChangeChecked}
                                name="check_compra"
                                color='secondary'
                            />
                        }
                        label="Compra"
                    />
                </div>
                <div className="table-responsive">
                    <table className="table p-table-global">
                        <thead className='p-thead-global'>
                            <tr className="text-center p-tr-titles-global">
                                <th className='text-start'>Categoría</th>
                                <th className='text-center'>Código</th>
                                <th>Tipo</th>
                                <th>Estado</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {categorias?.length > 0 && categorias?.map(item => (
                                <tr key={item.id} className='p-tr-body-global'>
                                    <ItemList
                                        openEdit={openEdit}
                                        openDelete={openDelete}
                                        item={item}
                                    />
                                </tr>
                            ))
                            }
                        </tbody>
                    </table>
                </div>
            </DialogContent>

            {openCat &&
                <DialogProfileCatalogCat
                    open={openCat}
                    setOpen={setOpenCat}
                    initialState={initialCat}
                    handleNewCat={() => { return false }}
                    handleUpdateCat={handleUpdateCat}
                    initLoadCategorias={() => { return false }}
                />
            }

        </Dialog>
    )
}

const ItemList = ({ item, openEdit, openDelete }) => {
    console.log('--cat--', item)
    return (
        <>
            <td className="text-start" style={{ textTransform: 'uppercase' }}>{item.nombre || '---'}</td>
            <td className="text-center">{item.codigo || '---'}</td>
            <td className="text-center">{item.tipo || '---'}</td>
            <td className="text-center" style={{ color: !item.estado ? 'red' : '' }}>
                {item.estado ? 'Activo' : 'Desactivado'}
            </td>
            <td className="text-center">
                <i className="bi bi-pencil" style={{ cursor: 'pointer' }} onClick={() => openEdit(item)}></i>
                <i className="bi bi-trash ms-3" style={{ cursor: 'pointer' }} onClick={() => openDelete(item)}></i>
            </td>
        </>
    )
}